<template>
  <v-card class="qr-code-generator tools-view-card">
    <ToolbarHeader :name="'QR Code Generator'"/>
    <v-container>
      <section class="ma-5">
        <v-form
            v-model="formOptions.valid"
            v-on:submit.prevent="generateQRCode"
        >
          <v-row justify="center">
            <v-col cols="12"
                   sm="12"
                   md="6">
              <v-text-field
                  required
                  name="UUID"
                  @input="qrCodeStatus = false"
                  v-model="form.qrCodeValue"
                  :rules="formOptions.qrCodeRules"
                  label="QR Code Value"
              />
            </v-col>
            <v-col cols="12"
                   sm="12"
                   md="2">
              <v-btn
                  color="primary"
                  class="mt-1 w-100"
                  @click="generateQRCode"
                  :disabled="!formOptions.valid"
              >
                Generate
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-row justify="center" v-if="qrCodeStatus">
          <v-col cols="12"
                 sm="12"
                 md="6">
            <div class="qr-code-generator qrcode-section text-center">
              <img id="qr-code-generator_section_image" v-cloak/>
            </div>
            <p class="text-center">
              {{ form.qrCodeValue }}
            </p>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import QRCode from 'qrcode';
import ToolbarHeader from "@/components/Toolbar-Header";

const form = {
  qrCodeValue: 'https://www.quasiris.de/de/'
};

const qrCodeGeneratorOptions = {
  errorCorrectionLevel: 'M',
  type: 'image/jpeg',
  quality: 2
};

export default {
  name: "QR-Code-Generator",
  components: {ToolbarHeader},
  data: () => ({
    qrCodeStatus: false,
    form: Object.assign({}, form),
    formOptions: {
      valid: false,
      qrCodeRules: [
        v => !!v || 'This value is required',
      ]
    },
  }),
  methods: {
    generateQRCode() {
      this.qrCodeStatus = true;
      setTimeout(() => {
        QRCode.toDataURL(this.form.qrCodeValue, qrCodeGeneratorOptions, (err, url) => {
          if (err) {
            this.qrCodeStatus = false;
            throw new Error(err);
          }
          const img = document.getElementById('qr-code-generator_section_image');
          img.src = url

        })
      }, 0);

    }
  }
}
</script>
<style type="text/css" scoped>
.qr-code-generator_section img {
  width: 100%;
  max-height: 300px;
  max-width: 300px;
}

[v-cloak] {
  display: none;
}

</style>
